import { store } from "../lib/store.js";
import { DEPARTMENTS } from "../data/departments.js";
import { agentsByDepartment } from "../data/agents.js";
import { createSpriteStateTracker, SPRITE_FRAME_ROW } from "../lib/sprite-state.js";
import { formatRelativeTime } from "../utils/format.js";

export function mountCityView(root) {
  root.innerHTML = `
    <section class="city-view" aria-label="Visão geral dos departamentos">
      ${DEPARTMENTS.map(
        (dept) => `
        <div class="department" data-department="${dept.id}" style="background-image: url('${dept.background}')">
          <div class="department-header">
            <span class="department-label">${dept.label}</span>
            <span class="department-activity" data-department-activity="${dept.id}"></span>
          </div>
          <div class="department-agents" data-department-agents="${dept.id}"></div>
        </div>
      `,
      ).join("")}
    </section>
  `;

  let rerenderScheduled = false;
  function requestRerender() {
    if (rerenderScheduled) return;
    rerenderScheduled = true;
    requestAnimationFrame(() => {
      rerenderScheduled = false;
      render(store.agentHealth.get());
    });
  }

  const tracker = createSpriteStateTracker(requestRerender);

  function render(healthMap) {
    for (const dept of DEPARTMENTS) {
      const agentsEl = root.querySelector(`[data-department-agents="${dept.id}"]`);
      const agents = agentsByDepartment(dept.id);
      let activeCount = 0;

      agentsEl.innerHTML = agents
        .map((agent) => {
          const health = healthMap.get(agent.agentName);
          const { frame, showThinkingBubble } = tracker.resolve(agent.agentName, health);
          const row = SPRITE_FRAME_ROW[frame];
          if (health && health.state !== "idle") activeCount += 1;

          const tooltip = health
            ? `${agent.label} — ${describeState(health.state)} (atualizado ${formatRelativeTime(health.updatedAt)})`
            : `${agent.label} — sem dados ainda`;

          return `
            <button
              class="agent-sprite-button"
              data-agent-name="${agent.agentName}"
              title="${escapeAttr(tooltip)}"
              aria-label="${escapeAttr(tooltip)}"
            >
              <span
                class="agent-sprite agent-sprite--${frame}"
                style="background-image: url('${agent.sprite}'); background-position-y: -${row * 48}px"
              ></span>
              ${showThinkingBubble ? '<span class="agent-thinking-bubble" aria-hidden="true">💭</span>' : ""}
            </button>
          `;
        })
        .join("");

      const activityEl = root.querySelector(`[data-department-activity="${dept.id}"]`);
      activityEl.textContent = activeCount > 0 ? `${activeCount} ativo${activeCount > 1 ? "s" : ""}` : "";
    }
  }

  root.addEventListener("click", (event) => {
    const button = event.target.closest(".agent-sprite-button");
    if (!button) return;
    store.selectedAgent.set(button.dataset.agentName);
  });

  const unsubscribe = store.agentHealth.subscribe((healthMap) => render(healthMap));

  return () => {
    unsubscribe();
    root.innerHTML = "";
  };
}

function describeState(state) {
  const labels = {
    idle: "ocioso",
    working: "trabalhando",
    thinking: "pensando",
    error: "erro",
    waiting_human: "aguardando aprovação",
  };
  return labels[state] ?? state;
}

function escapeAttr(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
